import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root',
})
export class DepartmentService {
  baseUrl = `departments`;
  headers = this.env.getCommonHeaders();
  baseDeptId: any = null;
  baseDeptIdAvlbl: boolean = false
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  fetchOrgDepartments(id: any,activeOnly?:boolean) {
    let query:any = {
      activeOnly:activeOnly
    }
    let url = `${this.baseUrl}/organisation/${id}?activeOnly=${activeOnly}`;
    return this.env.get(url);
  }
  fetchOrgDepartmentsWithStatus(id: any,activeOnly?:boolean) {
    let url = `${this.baseUrl}/v1/organisation/${id}?activeOnly=${activeOnly}`;
    return this.env.get(url);
  }
  saveOrgDepartment(params: any) {
    let url = `${this.baseUrl}`;
    return this.env.post(url, params);
  }

  updateOrgDepartment(editDataId: any, params: any) {
    let url = `${this.baseUrl}/${editDataId}`;
    return this.env.put(url, params);
  }

  fetchOrgMemberTypes(id: any, params: { [key: string]: any } = {}) {
    let url = `member-types/ordered/organisation/${id}`;
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== null &&
        params[key] !== ''
      ) {
        urlParams +=
          urlParams === ''
            ? `?${key}=${params[key]}`
            : `&${key}=${params[key]}`;
      }
    }
    return this.env.get(url + urlParams);
  }

  deleteDepartment(deptId: any) {
    let url = `${this.baseUrl}/${deptId}`;
    return this.env.delete(url);
  }

  //fetch duty mapped departments
  fetchDepartments(locId:any,params?: any) {
    const urlParams = this.buildUrlParams(params);
    let url = `${this.baseUrl}/location/${locId}${urlParams}`;
    return this.env.get(url);
  }

  updateDeptStatus(locDeptId:string, reqBody:any){
    let url = `${this.baseUrl}/${locDeptId}`;
    return this.env.patch(url,reqBody);
  }
  updateDepartmentState(data: any,deptId:any) {
    let url = `${this.baseUrl}/organisation/${deptId}`;
    return this.env.patch(url,data);
  }
  removeDept(locDeptId:string){
    let url = `${this.baseUrl}/location-department/${locDeptId}`;
    return this.env.delete(url);
  }

  private isLocalStorageAvailable() {
    let locAvl = typeof window !== 'undefined' && !!window.localStorage;
    if (locAvl) {
      this.baseDeptId = sessionStorage.getItem('baseDeptId');
      if (this.baseDeptId !==null){
        this.baseDeptIdAvlbl = true
      }
      else{
        this.baseDeptIdAvlbl = false
      }
    }
  }
  // Method to set the org ID (e.g., on login)
  setbaseDeptId(baseDeptId: string) {
    sessionStorage.setItem('baseDeptId', baseDeptId); // Persist to localStorage
  }

  // Method to clear the org ID (e.g., on logout)
  clearbaseDeptId() {
    sessionStorage.removeItem('baseDeptId'); // Clear from localStorage
  }

  // Method to get the current org ID value
  getbaseDeptId(): string | null {
    this.isLocalStorageAvailable();
    if (this.baseDeptIdAvlbl) {
      const storedData = this.baseDeptId;
      return storedData ? storedData : null;
    } else {
      return null;
    }
  }

  buildUrlParams(params: any): string {
    if (!params || typeof params !== 'object') {
      return '';
    }
  
    const urlParams = Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== '')
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
  
    return urlParams ? `?${urlParams}` : '';
  }
}
